<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="title"
    :width="width"
    append-to-body
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="名称" prop="dauName">
        <el-input
          v-model="form.dauName"

          placeholder="请输入DAU名称"
        />
      </el-form-item>
      <el-form-item label="设置DAU值" prop="dauNum">
        <el-input
          v-model="form.dauNum"

          placeholder="请输入DAU值"
        />
      </el-form-item>
      <el-table
        :data="tableData"
        v-if="Array.isArray(form.dspSlotId) && form.dspSlotId.length"
      >
        <el-table-column
          align="center"
          label="预算"
          prop="dspName"
        ></el-table-column>
        <el-table-column
          align="center"
          label="广告位"
          prop="dspSlotName"
        ></el-table-column>
        <el-table-column align="center" label="比例" prop="dauProportion">
          <template v-slot="scope">
            <div style="display: flex; align-items: center">
              <el-input
                oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>=100)value=100;if(value<0)value=0"
                v-model="scope.row.dauProportion"
              ></el-input>
              <span>%</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="down-tree">
        <el-tree
          :data="treeData"
          show-checkbox
          node-key="dspSlotId"
          :default-checked-keys="selectTreeData"
          ref="tree"
          highlight-current
          :props="defaultProps"
          @check="onCheck"
        >
        </el-tree>
      </div>
    </el-form>
    <div style="text-align: right">
      <el-button @click="close" >取消</el-button>
      <el-button
        @click="submit"
        type="primary"

        :loading="submitLoading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { DauMenuList, addDau, updateDau } from "@/api/manage/dsp/setDau";

const form = {
  dauName: undefined,
  dauNum: undefined,
  dspSlotId: [],
  addDauConfigInfos: [],
};
export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600,
    },
    data: Object,
    title: String,
  },
  emits: ["submit"],
  inject: ["init"],
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      rules: {
        dauName: [
          { required: true, message: "请输入DAU名称", trigger: "blur" },
        ],
        dauNum: [{ required: true, message: "请设置DAU值", trigger: "blur" }],
      },
      treeData: [],
      selectTreeData: [],
      defaultProps: {
        children: "dpsSlotNameResList",
        label: "dspName",
        disabled: "disabled",
      },
      tableData: [],
      tableList: [],
    };
  },
  computed: {},
  watch: {
    "form.dspSlotId"(newVal, oldVal) {
      this.tableData = [];
      let arr = [];
      this.tableList.forEach((item) => {
        item.dpsSlotNameResList?.forEach((sub) => {
          if (item.dspId === sub.dspId) {
            arr.push({
              dspName: item.dspName,
              dspSlotName: sub.dspSlotName,
              dspSlotId: sub.dspSlotId,
              dauProportion: sub.dauProportion ? sub.dauProportion : 0,
            });
          }
        });
      });
      if (newVal) {
        newVal.forEach((item) => {
          arr.forEach((sub) => {
            if (sub.dspSlotId === item) {
              this.tableData.push(sub);
            }
          });
        });
      }
    },
  },
  created() {},
  methods: {
    show(data) {
      this.dialogStatus = true;
      if (data) {
        this.form = Object.assign({}, data);
      }
      DauMenuList({ dauId: data?.dauId }).then((res) => {
        let selectTreeData = [];
        let currentSelectData = [];
        this.tableList = res.data.dspNameList;
        res.data.dspNameList.forEach((index) => {
          index.dpsSlotNameResList?.forEach((i) => {
            i.dspName = i.dspSlotName;
            if (i.status == 0) {
              return;
            } else if (i.status == 1) {
              selectTreeData.push(i.dspSlotId);
              currentSelectData.push(i.dspSlotId);
              i.disabled = false;
              i.a = index.dspName;
              this.tableData.push(i);
            } else if (i.status == 2) {
              selectTreeData.push(i.dspSlotId);
              i.disabled = true;
              index.disabled = true;
            }
          });
        });
        this.treeData = res.data.dspNameList;
        this.selectTreeData = selectTreeData;
        this.form.dspSlotId = currentSelectData;
      });
    },
    close() {
      this.dialogStatus = false;
      this.reset();
    },
    submit() {
      let sum = 0;
      this.form.dspSlotId = this.form.dspSlotId.filter((index) => {
        return index !== null && typeof index !== "undefined" && index !== "";
      });
      this.tableData.forEach((item) => {
        sum += Number(item.dauProportion);
      });
      if (sum > 100) {
        this.$message.warning("所有比例总合不能超过100");
        return;
      }
      this.form.addDauConfigInfos = this.tableData;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.dauId) {
            this.updateDau(this.form);
          } else {
            this.addDau(this.form);
          }
        }
      });
    },
    addDau(form) {
      this.submitLoading = true;
      addDau(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("新增成功");
            this.close();
            this.init();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    updateDau(form) {
      this.submitLoading = true;
      updateDau(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("编辑成功");
            this.close();
            this.init();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    reset() {
      this.form = Object.assign({}, form);
      this.tableData = [];
      this.$refs.form.resetFields();
    },
    onCheck(a, checkedNodes) {
      console.log(checkedNodes);
      let arr = [];
      checkedNodes.checkedNodes.forEach((index) => {
        if (index.status !== 2) {
          arr.push(index.dspSlotId);
        }
      });
      this.form.dspSlotId = arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
.down-tree {
  height: 250px;
  display: block;
  overflow-y: scroll;
}
</style>
